import classes from "../homePageNew.module.css";

/**
 * Three pulsing dots — shown over the list pane while a page navigation
 * (forward/back, or a search re-fetch) is in flight, on top of the still-
 * visible previous page's cards rather than replacing them outright.
 */
export default function ThreeDotLoader() {
  return (
    <span className={classes.threeDotLoader}>
      <span />
      <span />
      <span />
    </span>
  );
}
